import moment from 'moment-timezone';
import React, { useCallback, useEffect, useState } from 'react';


import './TabBallMetrics.scss';
import { Collapse } from 'antd';
import { fixDecimals } from 'helpers';
const { Panel } = Collapse;

type BallMetricsMobileType = {
        rows:any[]
  }

const BallMetricsMobile = ({rows}:BallMetricsMobileType) =>{

    return(
        <>
        <div style={{ height: '100%'}}>
        <div className="title-head">
                  BALL PERFORMANCE METRICS
                </div>
                <div className="body-collapse">
                <Collapse defaultActiveKey={['1']} className="ant-collapse-icon-position-right">
                    {rows.map((player,index)=>

                  <Panel
                    header={
                      <div className="collapse-h">
                        <h6>{player.playerName}</h6>
                        <h6>#{player.jerseyNumber}</h6>
                        <h6>{player.position}</h6>
                        <h6 className="total-r"><b>Total</b> {player.totalFlights}</h6>
                      </div>}
                    key={index +1}
                  >
                    <p><b>INITIAL AIR SPEED</b> <span><b>AVERAGE</b> {fixDecimals(player.avgInitAirSpeedInMph,1)} - <b>MAX </b>{fixDecimals(player.maxInitAirSpeedInMph,1)}</span></p>
                    <p><b>INITIAL ROTATION</b> <span><b>AVERAGE</b> {fixDecimals(player.avgInitRotation,0)} - <b>MAX</b> {fixDecimals(player.maxInitRotation,0)}</span></p>
                    <p><b>FLIGHT DURATION</b> <span><b>AVERAGE</b> {player.avgFlightDurInSec} - <b>MAX</b> {player.maxFlightDurInSec}</span></p>
                    <p><b>PEAK HEIGHT </b> <span><b>AVERAGE</b> {fixDecimals(player.avgPeakHeightInFeet,1)} - <b>MAX</b> {fixDecimals(player.maxPeakHeightInFeet,1)}</span></p>
                    <p><b>GROUND DISTANCE</b> <span><b>AVERAGE</b> {fixDecimals(player.avgGroundDistInYards,1)} - <b>MAX</b> {fixDecimals(player.maxGrounDistInYards,1)}</span></p>
                  </Panel>
                    )}
                </Collapse>
                </div>
            </div>
    </>
    );
};

export default BallMetricsMobile;
